<template>
  <el-dialog
      :visible="visible"
      :title="dialogTitle"
      width="900px"
      class="combo-dialog"
      @opened="afterOpen"
      @close="onClose"
  >
    <div class="scroll-wrap">
      <el-form ref="form" :model="comboForm" label-width="130px" class="combo-form">
        <!-- 基本信息区域 -->
        <div class="form-section">
          <div class="section-title">
            <i class="el-icon-document"></i>
            <span>基本信息</span>
          </div>
          <div class="section-content">
            <el-form-item
              label="方案名称"
              :rules="[{ required: true, message: '方案名称不能为空' }]"
              prop="comboName"
            >
              <el-input
                v-model="comboForm.comboName"
                :disabled="isViewMode"
                placeholder="请输入方案名称"
                class="combo-form-item"
                size="small"
              />
            </el-form-item>

            <el-form-item label="方案类型" prop="comboType">
              <el-select
                v-model="comboForm.comboType"
                :disabled="isViewMode || mode === 'edit'"
                placeholder="请选择方案类型"
                class="combo-form-item"
                size="small"
              >
                <el-option
                  v-for="item in dict.ComboTypeList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="方案等级">
              <el-radio-group v-model="comboForm.comboGrade" :disabled="isViewMode" class="grade-radio-group">
                <el-radio
                  v-for="item in dict.ComboGradeList"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="comboForm.comboType == 2" label="是否返点" prop="rewardStatus">
              <el-select
                  v-model="comboForm.rewardStatus"
                  placeholder="请选择是否返点"
                  class="combo-form-item"
                  size="small"
              >
                <el-option label="否" :value="false" />
                <el-option label="是" :value="true" />
              </el-select>
            </el-form-item>
          </div>
        </div>

        <!-- 费用设置区域 -->
        <div class="form-section">
          <div class="section-title">
            <i class="el-icon-coin"></i>
            <span>费用设置</span>
          </div>
          <div class="section-content">
            <el-form-item
              label="首付比例"
              prop="prepayRate"
              :rules="[{ type: 'number', required: true, message: '首付比例不能为空' }]"
            >
              <div class="input-with-unit">
                <el-input-number
                  v-model="comboForm.prepayRate"
                  :disabled="isViewMode"
                  placeholder="请输入首付比例"
                  :controls="false"
                  :min="0"
                  :max="100"
                  :precision="0"
                  class="combo-form-item"
                  size="small"
                />
                <span class="unit-text">%</span>
              </div>
            </el-form-item>

            <el-form-item
              label="费率"
              prop="priceRate"
              :rules="[{ type: 'number', required: true, message: '费率不能为空' }]"
            >
              <div class="input-with-unit">
                <el-input-number
                  v-model="comboForm.priceRate"
                  :disabled="isViewMode"
                  placeholder="请输入费率"
                  :controls="false"
                  :min="0"
                  :max="130"
                  :precision="0"
                  class="combo-form-item"
                  size="small"
                />
                <span class="unit-text">%</span>
              </div>
            </el-form-item>

            <el-form-item
              label="总期数"
              prop="billNum"
              :rules="[{ type: 'number', required: true, message: '总期数不能为空' }]"
            >
              <div class="input-with-unit">
                <el-input-number
                  v-model="comboForm.billNum"
                  :disabled="isViewMode"
                  placeholder="请输入总期数"
                  :controls="false"
                  :min="4"
                  :max="24"
                  :precision="0"
                  class="combo-form-item"
                  size="small"
                />
                <span class="unit-text">期</span>
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false" size="small">取 消</el-button>
      <el-button v-if="!isViewMode" type="primary" @click="onSubmit" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  EnumComboType,
  ComboTypeList,
  EnumComboGrade,
  ComboGradeList,
} from "@/enum/dict/index.js";
import { getComboDetail, createCombo, editCombo } from "./api.js";

export default {
  name: "StoreComboDetail",

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    id: {
      type: [Number, String],
      required: false,
      default: null,
    },
    mode: {
      type: String,
      required: true,
      validator: (value) => ["create", "edit", "view"].includes(value),
    },
  },

  data() {
    return {
      comboForm: {
        id: undefined,
        comboName: "",
        comboType: EnumComboType.COMMON,
        comboGrade: EnumComboGrade.A,
        rewardStatus: false,
        prepayRate: undefined,
        priceRate: undefined,
        billNum: undefined,
      },
      dict: { ComboTypeList, ComboGradeList },
    };
  },
  computed: {
    dialogTitle() {
      switch (this.mode) {
        case "create":
          return "新增方案";
        case "edit":
          return "编辑方案";
        case "view":
          return "方案详情";
        default:
          return "";
      }
    },

    isViewMode() {
      return this.mode === "view";
    },
  },

  methods: {
    async afterOpen() {
      if (this.mode === "create") {
        this.$refs.form.resetFields();
        this.$set(this, "comboForm", this.$options.data().comboForm);
        return;
      }
      const res = await getComboDetail({ id: this.id });
      this.comboForm = { ...res };
    },

    onClose() {
      this.$emit("update:visible", false);
    },

    async onSubmit() {
      const valid = await this.$refs.form.validate();
      if (!valid) {
        return;
      }
      if (this.comboForm.id) {
        await editCombo(this.comboForm);
      } else {
        await createCombo(this.comboForm);
      }
      this.$message({
        type: "success",
        message: "操作成功",
      });
      this.onClose();
      this.$emit("refreshList");
    },
  },
};
</script>

<style scoped lang="scss">
.combo-dialog {
  ::v-deep .el-dialog {
    border-radius: 8px;
    overflow: hidden;
  }

  ::v-deep .el-dialog__header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 20px 24px;
    border-bottom: none;

    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__close {
      color: #fff;
      font-size: 20px;

      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 24px;
    background: #f5f7fa;
  }

  ::v-deep .el-dialog__footer {
    padding: 16px 24px;
    background: #fff;
    border-top: 1px solid #e4e7ed;
  }

  ::v-deep .el-form-item__label {
    font-weight: 500;
    color: #606266;
    font-size: 14px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
}

.scroll-wrap {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }
}

.combo-form {
  .form-section {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .section-title {
      background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);
      padding: 14px 20px;
      border-bottom: 2px solid #e4e7ed;
      display: flex;
      align-items: center;
      font-size: 15px;
      font-weight: 600;
      color: #303133;

      i {
        margin-right: 8px;
        font-size: 16px;
        color: #667eea;
      }
    }

    .section-content {
      padding: 20px 24px;
    }
  }

  .combo-form-item {
    width: 100%;
    max-width: 320px;

    ::v-deep input {
      text-align: left;
      border-radius: 4px;
      transition: all 0.3s ease;

      &:focus {
        border-color: #667eea;
        box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
      }
    }

    ::v-deep .el-input__inner {
      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  .input-with-unit {
    display: flex;
    align-items: center;
    gap: 8px;

    .combo-form-item {
      flex: 1;
    }

    .unit-text {
      color: #909399;
      font-size: 14px;
      font-weight: 500;
      min-width: 20px;
    }
  }

  .grade-radio-group {
    ::v-deep .el-radio {
      margin-right: 24px;
      margin-bottom: 0;

      .el-radio__label {
        padding-left: 8px;
        font-size: 14px;
      }

      .el-radio__input.is-checked .el-radio__inner {
        background-color: #667eea;
        border-color: #667eea;
      }
    }
  }
}

.repay-section {
  .repay-wrap {
    padding: 20px 24px;
    min-height: 100px;
  }

  .repay-form-item {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    margin-bottom: 12px;
    background: #fafbfc;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    transition: all 0.3s ease;

    &:hover {
      background: #f5f7fa;
      border-color: #c0c4cc;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
    }

    &:last-child {
      margin-bottom: 0;
    }

    .repay-item-label {
      min-width: 80px;
      margin-right: 20px;

      .item-index {
        display: inline-block;
        padding: 4px 12px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: #fff;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
      }
    }

    .repay-item-content {
      flex: 1;
      display: flex;
      gap: 16px;
      align-items: center;

      .repay-form-field {
        flex: 1;
        margin-bottom: 0;

        ::v-deep .el-form-item__content {
          margin-left: 0 !important;
        }

        ::v-deep .el-select,
        ::v-deep .el-input-number {
          width: 100%;
        }

        ::v-deep .el-input__inner {
          border-radius: 4px;
          transition: all 0.3s ease;

          &:focus {
            border-color: #667eea;
            box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
          }
        }
      }
    }
  }

  .empty-repay-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    color: #909399;
    font-size: 14px;

    i {
      margin-right: 8px;
      font-size: 16px;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .el-button {
    padding: 10px 24px;
    border-radius: 4px;
    font-weight: 500;
    transition: all 0.3s ease;

    &.el-button--primary {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border: none;

      &:hover {
        opacity: 0.9;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
      }
    }

    &:not(.el-button--primary) {
      &:hover {
        color: #667eea;
        border-color: #667eea;
        background-color: #ecf5ff;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .combo-dialog {
    ::v-deep .el-dialog {
      width: 95% !important;
      margin: 5vh auto;
    }
  }

  .combo-form-item {
    max-width: 100% !important;
  }

  .repay-form-item {
    flex-direction: column;
    align-items: flex-start !important;

    .repay-item-label {
      margin-bottom: 12px;
      margin-right: 0;
    }

    .repay-item-content {
      flex-direction: column;
      width: 100%;
      gap: 12px;
    }
  }
}
</style>
